"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.weightsMap = exports.sizesMap = void 0;
var _fonts = require("../utils/fonts");
var sizesMap = {
  xs: _fonts.xsFontSize,
  sm: _fonts.smFontSize,
  md: _fonts.mdFontSize,
  lg: _fonts.lgFontSize,
  xl: _fonts.xlFontSize,
  xxl: _fonts.xxlFontSize
};
exports.sizesMap = sizesMap;
var weightsMap = {
  "default": _fonts.defaultFontWeight,
  attention: _fonts.attentionFontWeight,
  max: _fonts.maxFontWeight
};
exports.weightsMap = weightsMap;